import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { typeSelectorStyles } from "./style";
import solar from "../Assets/solar.svg";
import grid from "../Assets/grid.svg";
import battery from "../Assets/battery.svg";
import house from "../Assets/house.svg";
import evIcon from "../Assets/ev.svg";
import dollarIcon from "../Assets/dollar.svg";
import hotWaterIcon from "../Assets/hotwater.svg";
import { cloneDeep } from "lodash";

const OPTIONS = [
  { label: "Cost", value: "cost", icon: dollarIcon },
  { label: "Solar", value: "solar", icon: solar },
  { label: "Grid", value: "grid", icon: grid },
  { label: "Battery", value: "battery", icon: battery },
  { label: "House", value: "house", icon: house },
  { label: "EV", value: "ev", icon: evIcon },
  { label: "Hot Water", value: "hotwater", icon: hotWaterIcon },
];

const TypeSelector = ({
  selected = [],
  onChange,
  multi = false,
  showEv = false,
  showCost = false,
  showHotwater = false,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let filtered = OPTIONS;

    if (!showEv) {
      filtered = filtered.filter((it) => it.value !== "ev");
    }

    if (!showCost) {
      filtered = filtered.filter((it) => it.value !== "cost");
    }

    if (!showHotwater) {
      filtered = filtered.filter((it) => it.value !== "hotwater");
    }

    setOptions(filtered);
  }, [showEv, showCost, showHotwater]);

  useEffect(() => {
    setSelectedOptions(selected);
  }, [selected]);

  const onClick = (value) => {
    let list = cloneDeep(selectedOptions);
    if (multi) {
      if (list.includes(value)) {
        list = list.filter((it) => it !== value);
      } else {
        list.push(value);
      }
    } else {
      if (list.length > 0) {
        list[0] = value;
      } else {
        list.push(value);
      }
    }
    setSelectedOptions(list);
    onChange(list);
  };

  return (
    <Box className="type-selector" sx={(theme) => typeSelectorStyles(theme)} mb={1}>
      {options.map((item, i) => (
        <Box
          key={i}
          className={`item ${
            selectedOptions.includes(item.value)
              ? `${item.value + "-selected active"}`
              : ""
          }`}
          onClick={() => onClick(item.value)}
        >
          <img src={item.icon} alt="" className={`image ${item.value + "-icon"}`} />
          <Typography variant="caption" mt={0.5} fontWeight="600">
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default TypeSelector;
